module.exports = __webpack_public_path__ + "media/images/illustrations/moving_truck_small-03202ce196af8388e7024c54cd003190.svg";